import { useAuth } from '@/contexts/AuthContext';

export function useEquipmentAccess() {
  const { user, isAdmin, roles } = useAuth();
  
  // Guests see demo equipment only
  const shouldFilterDemo = !user;
  
  // Check if user has premium role (cast to any since new enum values may not be in types yet)
  const isPremium = (roles as string[]).includes('pro') || (roles as string[]).includes('business');
  
  return { 
    shouldFilterDemo, 
    isGuest: !user,
    isPremium,
    isAdmin 
  };
}
